import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { shuffleArray } from "../../../../utils";
import { GAME_OPTIONS_PATH, API_BASE_URL } from "../../../../constants";
import "./JegiPage.css";
import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { updateProgress, useVocabUnitData } from "../../../../database";
import ScoreDown from "./resources/kick0.jpg";
import ScoreUp from "./resources/kick1.jpg";

// A simple ScoreView component (you can adjust the visuals as needed)
function ScoreView() {
  return (
    <>
      <span className="score-circle"></span>
      <span className="score-circle"></span>
      <span className="score-skull"></span>
    </>
  );
}

function JegiPage() {
  const location = useLocation();
  const unit = location.state.unit;
  const category = location.state.category;

  const { data: vocabData, loading, error } = useVocabUnitData(unit.unit, unit.textbook);
  var questions = vocabData;
  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      questions = vocabData;
    }
    console.log(questions);
  }, [vocabData, loading]);

  // Timing constants
  const EASY_QUESTION_RESPONSE_TIME = 12000;
  const MEDIUM_QUESTION_RESPONSE_TIME = 8000;
  const HARD_QUESTION_RESPONSE_TIME = 5000;
  const RED_LIGHT_PAUSE_TIME = 2500;

  // Game state
  const [questionResponseTime, setQuestionResponseTime] = useState(5000);
  const [currQuestionIndex, setCurrQuestionIndex] = useState(0);
  const [currCorrectScore, setCurrCorrectScore] = useState(-1); // starts at -1 so that starting the game triggers a rerender
  const [currIncorrectScore, setCurrIncorrectScore] = useState(0);
  const [questionLanguage, setQuestionLanguage] = useState("");
  const [answerLanguage, setAnswerLanguage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showCorrectMessage, setShowCorrectMessage] = useState(false);
  const [timeLeft, setTimeLeft] = useState(questionResponseTime);
  const [state, setState] = useState({
    questions: [],
  });

  const openTutorial = () => {
    document.getElementById("pregame-div").style.display = "none";
    document.getElementById("tutorial").style.display = "flex";
    document.getElementById("postgame-div").style.display = "none";
  };

  const closeTutorial = () => {
    document.getElementById("pregame-div").style.display = "flex";
    document.getElementById("tutorial").style.display = "none";
    document.getElementById("postgame-div").style.display = "none";
  };

  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });

  useEffect(() => {
    if (!loading && vocabData.length > 0) {
      setState((prevState) => {
        if (JSON.stringify(prevState.questions) !== JSON.stringify(vocabData)) {
          return {
            ...prevState,
            questions: vocabData,
          };
        }
        return prevState;
      });
    }
  }, [vocabData, loading]);

  // Function to start the game
  const startGame = () => {
    const difficulty = document.querySelector(
      'input[name="difficulty"]:checked'
    )?.value;
    const selectedAnswerLanguage = document.querySelector(
      'input[name="answer-language"]:checked'
    )?.value;

    if (!difficulty || !selectedAnswerLanguage) {
      alert("Please select both difficulty and answer language!");
      return;
    }

    // Set answer and question languages based on selection
    setAnswerLanguage(
      selectedAnswerLanguage === "korean" ? "korean" : "englishLiterals"
    );
    setQuestionLanguage(
      selectedAnswerLanguage === "korean" ? "english" : "korean"
    );

    // Set the response time based on difficulty
    if (difficulty === "easy") {
      setQuestionResponseTime(EASY_QUESTION_RESPONSE_TIME);
    } else if (difficulty === "medium") {
      setQuestionResponseTime(MEDIUM_QUESTION_RESPONSE_TIME);
    } else {
      setQuestionResponseTime(HARD_QUESTION_RESPONSE_TIME);
    }

    // Shuffle questions and reset scores
    shuffleArray(state.questions);
    setCurrCorrectScore(1);
    setCurrIncorrectScore(0);
    setCurrQuestionIndex(0);

    // Reset score view UI
    const scoreView = document.getElementById("score-view");
    if (scoreView) {
      for (let i = 0; i < scoreView.childNodes.length; i++) {
        scoreView.childNodes[i].classList.remove("red");
      }
    }

    // Hide pregame and tutorial sections; show the game
    document.getElementById("pregame-div").style.display = "none";
    document.getElementById("tutorial").style.display = "none";
    document.getElementById("postgame-div").style.display = "none";
    document.getElementById("win-text").style.display = "none";
    document.getElementById("lose-text").style.display = "none";
    document.getElementById("game-div").style.display = "flex";
    document.getElementById("jegi-help-button").style.display = "none";
  };

  // Function to reset the game view for playing again
  const playAgain = () => {
    document.getElementById("pregame-div").style.display = "flex";
    document.getElementById("tutorial").style.display = "none";
    document.getElementById("postgame-div").style.display = "none";
    document.getElementById("jegi-help-button").style.display = "flex";
  };

  // Function to submit an answer
  const submitAnswer = () => {
    const submission = document.getElementById("answer-input").value;
    document.getElementById("answer-input").value = "";

    let correctAnswers = state.questions[currQuestionIndex][answerLanguage];
    if (!Array.isArray(correctAnswers)) {
      correctAnswers = [correctAnswers];
    }
    console.log(document.getElementById("score-image").getAttribute("src"));

    if (correctAnswers.includes(submission)) {
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "jegi", true);
      }
      setCurrCorrectScore(currCorrectScore + 1);
      setShowCorrectMessage(true);

      document.getElementById("score-image").setAttribute("src", ScoreUp);
      console.log(document.getElementById("score-image").getAttribute("src"));

      // Hide the question div to prevent accidental submissions
      document.getElementById("question-div").style.display = "none";
      if (currCorrectScore === 5) {
        document.getElementById("game-div").style.display = "none";
        document.getElementById("postgame-div").style.display = "flex";
        document.getElementById("win-text").style.display = "flex";
      }
      setTimeout(() => {
        setShowCorrectMessage(false);
        setCurrQuestionIndex((currQuestionIndex + 1) % state.questions.length);
        // Show the question div for the next question
        document.getElementById("question-div").style.display = "flex";
        document.getElementById("score-image").setAttribute("src", ScoreDown);
        console.log(document.getElementById("score-image").getAttribute("src"));
      }, 1500);
    } else {
      setShowErrorMessage(true);
      const scoreView = document.getElementById("score-view");
      if (scoreView && scoreView.childNodes[currIncorrectScore]) {
        scoreView.childNodes[currIncorrectScore].classList.add("red");
      }
      document.getElementById("question-div").style.display = "none";
      setCurrIncorrectScore(currIncorrectScore + 1);
      if (user) {
        updateProgress(user.email, unit.unit, unit.textbook, "jegi", false);
      }
      setTimeout(() => {
        setShowErrorMessage(false);
        if (currIncorrectScore === 2) {
          document.getElementById("game-div").style.display = "none";
          document.getElementById("postgame-div").style.display = "flex";
          document.getElementById("lose-text").style.display = "flex";
        }
        setCurrQuestionIndex((currQuestionIndex + 1) % state.questions.length);
        document.getElementById("question-div").style.display = "flex";
      }, RED_LIGHT_PAUSE_TIME);
    }
  };

  // Timer hook for handling unanswered questions
  useEffect(() => {
    const prevScoreTotal = currCorrectScore + currIncorrectScore;
    const interval = setInterval(() => {
      if (document.getElementById("game-div").style.display === "flex") {
        // only active during the game
        if (prevScoreTotal === currCorrectScore + currIncorrectScore) {
          setShowErrorMessage(true);
          const scoreView = document.getElementById("score-view");
          if (scoreView && scoreView.childNodes[currIncorrectScore]) {
            scoreView.childNodes[currIncorrectScore].classList.add("red");
          }
          document.getElementById("question-div").style.display = "none";
          setCurrIncorrectScore(currIncorrectScore + 1);
          if (user) {
            updateProgress(user.email, unit.unit, unit.textbook, "jegi", false);
          }
          setTimeout(() => {
            setShowErrorMessage(false);
            setCurrQuestionIndex(
              (currQuestionIndex + 1) % state.questions.length
            );
            document.getElementById("question-div").style.display = "flex";
            if (currIncorrectScore === 2) {
              document.getElementById("game-div").style.display = "none";
              document.getElementById("postgame-div").style.display = "flex";
              document.getElementById("lose-text").style.display = "flex";
            }
          }, RED_LIGHT_PAUSE_TIME);
        }
      }
    }, questionResponseTime);
    return () => clearInterval(interval);
  }, [
    currQuestionIndex,
    currCorrectScore,
    currIncorrectScore,
    questionResponseTime,
    state.questions.length,
  ]);

  useEffect(() => {
    // Reset the timer to the full response time whenever the question changes
    setTimeLeft(questionResponseTime);
    const timerInterval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 100) {
          clearInterval(timerInterval);
          return 0;
        }
        return prevTime - 100;
      });
    }, 100);
    return () => clearInterval(timerInterval);
  }, [currQuestionIndex, questionResponseTime]);
  // Wait for questions to load and ensure they're not empty
  if (loading || questions.length === 0) {
    return (
      <div className="loading-screen">
        <h2>Loading vocabulary questions...</h2>
      </div>
    );
  }

  // Show error message if data fetch failed
  if (error) {
    return (
      <div className="error-screen">
        <h2>Error loading vocabulary questions: {error}</h2>
      </div>
    );
  }

  return (
    <div id="jegi-page">
      <div className="animation-container">
        <img id="score-image" src={ScoreDown} />
      </div>
      <div id="header">
        <button
          type="button"
          id="jegi-help-button"
          className="jegi-help-button"
          onClick={openTutorial}
          aria-label="Open Jegi tutorial"
        >
          ?
        </button>
        <h1>{unit.name}</h1>
        <div id="pregame-div">
          <div id="settings-div">
            <b>Difficulty Level:</b>
            <input type="radio" id="easy" name="difficulty" value="easy" />
            <label htmlFor="easy">Easy</label>
            <input type="radio" id="medium" name="difficulty" value="medium" />
            <label htmlFor="medium">Medium</label>
            <input type="radio" id="hard" name="difficulty" value="hard" />
            <label htmlFor="hard">Hard</label>
            <br />
          </div>
          <div id="settings-div">
            <b>Answer Language:</b>
            <input
              type="radio"
              id="english"
              name="answer-language"
              value="english"
            />
            <label htmlFor="english">English</label>
            <input
              type="radio"
              id="korean"
              name="answer-language"
              value="korean"
            />
            <label htmlFor="korean">Korean</label>
          </div>
          <button className="btn btn-primary" onClick={startGame}>
            Start Game
          </button>
        </div>
        <div id="game-div" style={{ display: "none" }}>
          <div id="game-container">
            <div id="game-info">
              <div id="timer">Time Left: {Math.ceil(timeLeft / 1000)} s</div>
              <div id="counters">
                <div id="score-counter">
                  Score: {currCorrectScore >= 0 ? currCorrectScore - 1 : 0}
                </div>
                <div id="lives-counter">Lives: {3 - currIncorrectScore}</div>
              </div>
              <div id="score-view">
                <ScoreView />
              </div>
            </div>
            <div id="question-container">
              {showErrorMessage && (
                <div id="error">
                  <h2 id="error-message">Incorrect answer!</h2>
                  <h3 id="error-message">
                    The right answer is:{" "}
                    {Array.isArray(
                      state.questions[currQuestionIndex][answerLanguage]
                    )
                      ? state.questions[currQuestionIndex][answerLanguage].map(
                          (item, idx) => <li key={idx}>{item}</li>
                        )
                      : state.questions[currQuestionIndex][answerLanguage]}
                  </h3>
                </div>
              )}
              {showCorrectMessage && (
                <div id="correct">
                  <h2 id="correct-message">Correct answer! Good job!</h2>
                </div>
              )}
              <div id="question-div">
                <h4>Question:</h4>
                <h2>
                  What is{" "}
                  <span id="question-text">
                    {answerLanguage === "korean" ? (
                      <img
                        src={`${API_BASE_URL}/${questions[currQuestionIndex].imgPath}`}
                        width="180"
                        height="200"
                      />
                    ) : (
                      questions[currQuestionIndex].korean
                    )}
                  </span>{" "}
                  in {answerLanguage === "korean" ? "Korean" : "English"}?
                </h2>
                <div id="answer">
                  <input
                    id="answer-input"
                    type="text"
                    autoComplete="off"
                    onKeyDown={(event) => {
                      if (event.key === "Enter") submitAnswer();
                    }}
                  />
                  <button className="btn btn-primary" onClick={submitAnswer}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="postgame-div" style={{ display: "none" }}>
          <h2 id="win-text" style={{ display: "none" }}>
            You win!
          </h2>
          <h2 id="lose-text" style={{ display: "none" }}>
            You lose!
          </h2>
          <button className="btn btn-primary" onClick={playAgain}>
            Play Again
          </button>
        </div>
        <div id="tutorial">
          <h2>Jegi Game Tutorial</h2>
          <p>
            <b>Goal:</b> Answer vocabulary questions correctly to keep the jegi
            moving and reach 5 correct answers before you lose all your lives.
          </p>
          <p>
            <b>How to Play:</b>
            <br />
            1. Choose a difficulty level and answer language before starting.
            <br />
            2. Read the word shown on the screen.
            <br />
            3. Type the translation in the selected answer language.
            <br />
            4. Press Enter or click Submit to lock in your answer.
          </p>
          <p>
            <b>Rules:</b>
            <br />
            Correct answers increase your score.
            <br />
            Wrong answers or unanswered questions cost one life.
            <br />
            The round ends when you get 5 correct answers or lose 3 lives.
          </p>
          <p>
            <b>Difficulty:</b>
            <br />
            Easy gives you the most time to answer.
            <br />
            Medium shortens the response time.
            <br />
            Hard gives you the least time and requires faster typing.
          </p>
          <button className="btn btn-primary" onClick={closeTutorial}>
            Back to Game Setup
          </button>
        </div>
        <Link
          to={GAME_OPTIONS_PATH}
          state={{ unit: unit, category: category }}
          className="game-options-back-link"
        >
          <button className="btn btn-back game-options-back-button">Back</button>
        </Link>
      </div>
    </div>
  );
}

export default JegiPage;
